module.exports = __webpack_public_path__ + "static/media/2-en.8d77db15.svg";